import { atomWithReset as stateSegmentWithReset } from 'jotai/utils';

export type ContentConfig = {
  recommendImages?: boolean;
  enableTranslation?: boolean;
  enableExtendedKnowledge?: boolean;
  isLoading?: boolean;
};

export const contentConfigStateSegment = stateSegmentWithReset<ContentConfig>({
  recommendImages: true,
  enableTranslation: false,
  enableExtendedKnowledge: false,
  isLoading: true, // Default to true - disabled until API responds
});
contentConfigStateSegment.debugLabel = 'contentConfigStateSegment';
